import { render, staticRenderFns } from "./listFooter.vue?vue&type=template&id=b9bd5064"
import script from "./listFooter.vue?vue&type=script&lang=js"
export * from "./listFooter.vue?vue&type=script&lang=js"
import style0 from "./listFooter.vue?vue&type=style&index=0&id=b9bd5064&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports